import { useState } from 'react';
import type { CustomClassModalData, PreSelectedClass } from '../types';

const useCustomClassModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [road, setRoad] = useState<'main' | 'rightBorder' | 'leftBorder'>(
    'main'
  );

  const [preSelectedClass, setPreSelectedClass] =
    useState<PreSelectedClass>(undefined);

  const [customClassData, setCustomClassData] = useState<CustomClassModalData>({
    mainCustomClass: undefined,
    rightBorderCustomClass: undefined,
    leftBorderCustomClass: undefined,
  });

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const updateRoad = (value: 'main' | 'rightBorder' | 'leftBorder') => {
    setRoad(value);
  };

  const updateData = (data: CustomClassModalData) => {
    console.log('updateData from hook anis', data);
    setPreSelectedClass(undefined);
    setCustomClassData(data);
  };

  return {
    isOpen,
    road,
    customClassData,
    preSelectedClass,
    setPreSelectedClass,
    openModal,
    closeModal,
    updateRoad,
    setCustomClassData: updateData,
  };
};

export default useCustomClassModal;
